let data = {}
let store = {
  get (key) {
    return data[key]
  },
  set (key, value) {
    data[key] = value
    this.save()
  },
  save () {
    localStorage.setItem('localStore', JSON.stringify(data))
  },
  load () {
    if (localStorage.getItem('localStore')) {
      let loaded = JSON.parse(localStorage.getItem('localStore'))
      if (loaded) {
        data = loaded
      }
    }
  }
}

store.load()

export default store



// WEBPACK FOOTER //
// ./src/store/local.js